import capitalize from './capitalize';
export default function capitalizeSentenceCase(string, separator = ' ') {
  const sentence = string.toLowerCase().split(`${separator}`);

  for (let i in sentence) {
    sentence[i] = capitalize(sentence[i]);
  }

  return sentence.join(`${separator}`);
}